import { Text, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useRedeemSummaryContext } from '../../../../contexts/redeem-summary';
import { ExportButton } from '../ExportButton';
import { InfoTooltip } from '../InfoTooltip';
import { StatusSection } from '../StatusSection';

interface ReviewSummaryProps {}

export const ReviewSummary: React.FC<ReviewSummaryProps> = () => {
  const { redeemRowsDetailsRecords, handleExportErrorRegister, isExportingErrorRegister } =
    useRedeemSummaryContext();
  const Wrapper = useBreakpointValue({
    base: ({ children }) => (
      <VStack
        direction={{ base: 'column', lg: 'row' }}
        space={Spacing['stack.nano']}
        justifyContent="space-between">
        {children}
      </VStack>
    ),
    lg: ({ children }) => children,
  });
  return (
    <Wrapper>
      <StatusSection
        title="Total de Registros"
        status={
          <Text color="neutral.black" variant="semibold">
            {redeemRowsDetailsRecords?.total}
          </Text>
        }
      />
      <StatusSection
        title="Registros válidos"
        status={
          <Text color="neutral.black" variant="semibold">
            {redeemRowsDetailsRecords?.valid}
          </Text>
        }
      />
      <StatusSection
        title={<InfoTooltip text="Registros com erro" />}
        status={
          <ExportButton
            isLoading={isExportingErrorRegister}
            onPress={handleExportErrorRegister}
            count={redeemRowsDetailsRecords?.error}
          />
        }
      />
    </Wrapper>
  );
};
